import React from 'react';
import styled from '@emotion/styled';
import fonts from 'style/fonts';
import { mq } from 'style/variables';
import { text } from 'style/mixin';
import sizes from 'style/sizes';
import colors from 'style/colors';
import { EnHeading } from 'components/atoms/enHeading';
import { Button } from 'components/atoms/button';

type OutlineProps = {
  outlines: Array<string>;
  visitUrl?: string;
  // 20240701の改修にて、一番工数の少ない方法を取るためにコンポーネント内部に情報をベタ書きするアクロバティックな方法を取る
  showAhamoInformation?: boolean;
};

const Container = styled.div`
  display: block;
  position: relative;
  ${mq.onlypc} {
    padding: ${sizes.margin[48]};
    background-color: ${colors.gray03};
  }
`;

const Title = styled.div`
  margin-bottom: ${sizes.margin[32]};
  ${mq.onlysp} {
    margin-bottom: ${sizes.margin[24]};
  }
`;

const Outlines = styled.div`
  font-family: ${fonts.enGothic};
  letter-spacing: 0.07em;
  ${mq.onlypc} {
    ${text(12, 2, true)};
  }
  ${mq.onlysp} {
    ${text(12, 2, true)};
  }

  & > span {
    display: inline-block;
    white-space: nowrap;
    &:not(:last-of-type) {
      &::after {
        content: ',';
        padding-left: 0.5em;
        padding-right: 0.5em;
      }
    }
  }
`;

const Btns = styled.div`
  ${mq.onlypc} {
    margin-top: 32px;
  }
  ${mq.onlysp} {
    margin-top: 24px;
  }
  > a {
    ${mq.onlysp} {
      width: 100%;
      height: 48px;
      font-size: 15px;
    }
  }

  > a + a {
    margin-top: 16px;
  }
`;

export const Outline: React.FC<OutlineProps> = props => {
  return (
    <Container {...props}>
      <Title>
        <EnHeading size={'xsmall'}>{props.showAhamoInformation ? 'Download' : 'Solution / Output'}</EnHeading>
      </Title>
      {!props.showAhamoInformation && (
        <Outlines>
          {props.outlines.map((item, idx) => (
            <span key={idx}>{item}</span>
          ))}
        </Outlines>
      )}

      {props.visitUrl && (
        <Btns>
          {!props.showAhamoInformation ? (
            <Button type="fill" href={props.visitUrl} blank>
              Visit Website
            </Button>
          ) : (
            <>
              <Button href="https://apps.apple.com/jp/app/ahamo-%E3%82%A2%E3%83%8F%E3%83%A2/id1542920778" blank>
                App Store
              </Button>
              <Button href="https://play.google.com/store/apps/details?id=com.nttdocomo.android.myahamo " blank>
                Google Play
              </Button>
            </>
          )}
        </Btns>
      )}
    </Container>
  );
};
